<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
      <template #layoutContent>
        <Card :title="$t('user.contracts')">
          <template #cardBody>
            <Contract/>
          </template>
        </Card>
          
          
      </template>
  </SubLayout>
</template>



<script setup>
import Card from '@/components/Card.vue';
import Contract from '../Employee/Contract.vue';
import SubLayout from '../Layouts/partials/SubLayout.vue';

const title = i18n.global.t('user.contracts')
const breadcrumbs = [
{
  name: i18n.global.t('user.contracts'),
  path: '/'
},
]

</script>
